import { FooterLabels } from './build-labels';

type FooterUrls = {
  policiesUrl: string;
  cookiesUrl: string;
  privacyUrl: string;
  termsUrl: string;
  acceptableUseUrl: string;
  socialMediaUrl: string;
  disclosurePolicyUrl: string;
  speakUpUrl: string;
};

export type GlobalFooter = {
  legalPolicies: { label: string; url: string };
  cookies: { label: string; url: string };
  privacy: { label: string; url: string };
  termsOfUse: { label: string; url: string };
  acceptableUse: { label: string; url: string };
  socialMedia: { label: string; url: string };
  disclosurePolicy: { label: string; url: string };
  manageCookies: { label: string; url: string };
  speakUp: { label: string; url: string };
};

export const buildGlobalFooterData = (
  urls: FooterUrls,
  labels: FooterLabels
): GlobalFooter => ({
  legalPolicies: { label: labels.legalPolicies, url: urls.policiesUrl },
  cookies: { label: labels.cookies, url: urls.cookiesUrl },
  privacy: { label: labels.privacy, url: urls.privacyUrl },
  termsOfUse: { label: labels.termsOfUse, url: urls.termsUrl },
  acceptableUse: { label: labels.acceptableUse, url: urls.acceptableUseUrl },
  socialMedia: { label: labels.socialMedia, url: urls.socialMediaUrl },
  disclosurePolicy: {
    label: labels.disclosurePolicy,
    url: urls.disclosurePolicyUrl
  },
  manageCookies: { label: labels.manageCookies, url: '#cbg-manage-cookies' },
  speakUp: { label: labels.speakUp, url: urls.speakUpUrl }
});

export const updateGlobalFooterLabels = (
  footer: GlobalFooter,
  labels: FooterLabels
): GlobalFooter => ({
  ...footer,
  legalPolicies: { ...footer.legalPolicies, label: labels.legalPolicies },
  cookies: { ...footer.cookies, label: labels.cookies },
  privacy: { ...footer.privacy, label: labels.privacy },
  termsOfUse: { ...footer.termsOfUse, label: labels.termsOfUse },
  acceptableUse: { ...footer.acceptableUse, label: labels.acceptableUse },
  socialMedia: { ...footer.socialMedia, label: labels.socialMedia },
  disclosurePolicy: {
    ...footer.disclosurePolicy,
    label: labels.disclosurePolicy
  },
  manageCookies: { ...footer.manageCookies, label: labels.manageCookies },
  speakUp: { ...footer.speakUp, label: labels.speakUp }
});
